import * as React from "react";
import * as M from "../../models";

interface OwnProps {
    field: M.FormBuilder.Field;
}

interface OwnState {
}

export class FieldDisplay extends React.Component<OwnProps, OwnState> {
    public render() {
        return this.props.field.field;
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/FieldDisplay.tsx